"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MERKLE_DISTRIBUTOR_PROGRAM_ID = exports.PROGRAM_ID = void 0;
const web3_js_1 = require("@solana/web3.js");
exports.PROGRAM_ID = new web3_js_1.PublicKey("EqaUmBqKuUsS8C1HwvckQymErozrmzzivxkP9CazU2mX");
exports.MERKLE_DISTRIBUTOR_PROGRAM_ID = exports.PROGRAM_ID;
